import { ReactElement, useEffect, useRef } from 'react';
import { useModal } from 'yoso';
import { useUnmount } from '~/components/Util/react';

export type OpenModalProps = {
  disabled: boolean;
  children: ReactElement;
  onClose?: (value: { confirmed: boolean }) => void;
};

export const OpenModal = ({
  children: modal,
  disabled = true,
  onClose = () => {},
}: OpenModalProps) => {
  const { open, close } = useModal();

  const openedRef = useRef(false);

  const closeCallbackRef = useRef(onClose);
  closeCallbackRef.current = onClose;

  useEffect(() => {
    if (!disabled && !openedRef.current) {
      openedRef.current = true;
      open(modal).then((data) => {
        closeCallbackRef.current(data);
        openedRef.current = false;
      });
    }
    // eslint-disable-next-line
  }, [disabled]);

  useUnmount(close);

  return null;
};
